function updateCartIconBubble(itemCount) {
  const bubbleParent = document.getElementById('cart-icon-bubble');
  if (!bubbleParent) return;

  const count = parseInt(itemCount, 10) || 0;
  const existingBubble = bubbleParent.querySelector('.cart-count-bubble');

  if (count < 1) {
    if (existingBubble) existingBubble.remove();
    return;
  }

  if (existingBubble) {
    existingBubble.textContent = count;
    existingBubble.style.opacity = '1';
    return;
  }

  const bubble = document.createElement('span');
  bubble.className =
    'absolute -top-1 -right-1 bg-accent text-white rounded-full w-5 h-5 flex items-center justify-center text-xs cart-count-bubble';
  bubble.textContent = count;
  bubbleParent.appendChild(bubble);
}

function refreshCartIconBubble() {
  const cartJsUrl =
    window.routes && window.routes.cart_url
      ? window.routes.cart_url.replace(/\/cart\/?$/, '/cart.js')
      : '/cart.js';

  return fetch(cartJsUrl)
    .then((response) => response.json())
    .then((cart) => {
      updateCartIconBubble(cart.item_count);
      return cart.item_count;
    })
    .catch((error) => {
      console.error('Error fetching cart count:', error);
      return null;
    });
}

window.updateCartIconBubble = updateCartIconBubble;
window.refreshCartIconBubble = refreshCartIconBubble;

function getCartLadderFillWidth() {
  const fill = document.querySelector('.cart-ladder__fill');
  if (!fill) return 0;
  return fill.getBoundingClientRect().width;
}

function getCartLadderTargetFillWidth(ladder) {
  const allTiers = ladder.querySelectorAll('.cart-ladder__tier');
  const unlockedTiers = ladder.querySelectorAll('.cart-ladder__tier.is-unlocked');
  if (!unlockedTiers.length) return 0;

  if (allTiers.length > 0 && unlockedTiers.length === allTiers.length) {
    return ladder.getBoundingClientRect().width;
  }

  const lastTier = unlockedTiers[unlockedTiers.length - 1];
  const node = lastTier.querySelector('.cart-ladder__node');
  if (!node) return 0;

  const ladderRect = ladder.getBoundingClientRect();
  const nodeRect = node.getBoundingClientRect();
  return nodeRect.left + nodeRect.width / 2 - ladderRect.left;
}

function lockCartLadderFill(width) {
  const fill = document.querySelector('.cart-ladder__fill');
  if (!fill) return;

  fill.style.transition = 'none';
  fill.style.width = width + 'px';
}

function initCartLadderFill() {
  const ladder = document.querySelector('.cart-ladder');
  const fill = ladder && ladder.querySelector('.cart-ladder__fill');
  if (!fill) return;

  const targetWidth = getCartLadderTargetFillWidth(ladder);
  fill.style.transition = 'none';
  fill.style.width = targetWidth + 'px';
  fill.offsetHeight;
  fill.style.transition = '';
}

function animateCartLadderFill(fromWidth) {
  const ladder = document.querySelector('.cart-ladder');
  const fill = ladder && ladder.querySelector('.cart-ladder__fill');
  if (!fill) return;

  const targetWidth = getCartLadderTargetFillWidth(ladder);
  const startWidth = typeof fromWidth === 'number' ? fromWidth : 0;

  fill.style.transition = 'none';
  fill.style.width = startWidth + 'px';
  fill.offsetHeight;

  if (Math.abs(startWidth - targetWidth) < 1) {
    fill.style.transition = '';
    fill.style.width = targetWidth + 'px';
    return;
  }

  fill.style.transition = '';
  fill.style.width = targetWidth + 'px';
}

function runCartDrawerDomUpdate(updateFn) {
  const previousFillWidth = getCartLadderFillWidth();
  updateFn();
  lockCartLadderFill(previousFillWidth);

  requestAnimationFrame(() => {
    animateCartLadderFill(previousFillWidth);
  });
}

window.animateCartLadderFill = animateCartLadderFill;
window.getCartLadderFillWidth = getCartLadderFillWidth;
window.initCartLadderFill = initCartLadderFill;
window.lockCartLadderFill = lockCartLadderFill;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.reconcileProteinSplit().then(() => {
      this.dedupeGiftItems();
    });
  }

  reconcileProteinSplit() {
    const split = window.ForallProteinSplit;
    if (!split || typeof split.isEnabled !== 'function' || !split.isEnabled()) {
      return Promise.resolve(null);
    }
    if (this._proteinReconcileInProgress) return Promise.resolve(null);

    this._proteinReconcileInProgress = true;
    const sections = {
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    return split
      .reconcileKitQty(sections)
      .then((parsedState) => {
        if (!parsedState) return null;

        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems && typeof cartDrawerItems.renderSections === 'function') {
          cartDrawerItems.renderSections(parsedState);
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        if (typeof window.refreshCartIconBubble === 'function') {
          window.refreshCartIconBubble();
        }
        return parsedState;
      })
      .catch(() => null)
      .finally(() => {
        this._proteinReconcileInProgress = false;
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.scrollY = window.scrollY || window.pageYOffset || 0;
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    initCartLadderFill();
    this.dedupeGiftItems();
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');

    const scrollY =
      typeof this.scrollY === 'number'
        ? this.scrollY
        : window.scrollY || window.pageYOffset || 0;

    removeTrapFocus();
    if (this.activeElement && typeof this.activeElement.focus === 'function') {
      try {
        this.activeElement.focus({ preventScroll: true });
      } catch (err) {
        this.activeElement.focus();
      }
    }

    document.body.classList.remove('overflow-hidden');
    window.scrollTo(0, scrollY);

    const drawerInner = this.querySelector('.drawer__inner');
    if (!drawerInner) return;

    drawerInner.addEventListener(
      'transitionend',
      (event) => {
        if (event.target !== drawerInner || event.propertyName !== 'transform') return;
        this.classList.remove('animate');
      },
      { once: true }
    );
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const isEmpty = !parsedState || parsedState.item_count === 0;
    this.classList.toggle('is-empty', isEmpty);

    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.toggle('is-empty', isEmpty);
    }

    this.productId = parsedState.id;

    runCartDrawerDomUpdate(() => {
      this.getSectionsToRender().forEach((section) => {
        const sectionHtml = parsedState.sections && parsedState.sections[section.id];
        if (!sectionHtml) return;

        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });
    });

    refreshCartIconBubble();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      initCartLadderFill();
      this.reconcileProteinSplit().then(() => {
        this.dedupeGiftItems();
      });
      this.open();
    });
    console.log("not empty!");
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const element = doc.querySelector(selector);
  if (!element) {
    console.warn(`Selector "${selector}" not found in returned HTML`);
    return ''; 
  }
  return element.innerHTML;
}


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  dedupeGiftItems() {
    if (this._giftDedupeInProgress) return;
    this._giftDedupeInProgress = true;

    const cartJsUrl =
      window.routes && window.routes.cart_url
        ? window.routes.cart_url.replace(/\/cart\/?$/, '/cart.js')
        : '/cart.js';

    fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Cart fetch error');
        return response.json();
      })
      .then((cart) => {
        if (!cart.items || cart.items.length === 0) return null;

        const gifts = [];

        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (item.properties && item.properties._gift_item) {
            gifts.push(item);
          }
        }

        if (gifts.length === 0) return null;

        const isGiftItem = function (item) {
          return Boolean(item && item.properties && item.properties._gift_item);
        };

        const giftHasParent = function (gift) {
          const parentId =
            gift.properties && gift.properties._gift_item
              ? String(gift.properties._gift_item)
              : '';

          for (let i = 0; i < cart.items.length; i++) {
            const item = cart.items[i];
            if (isGiftItem(item)) continue;
            if (parentId && String(item.product_id) === parentId) return true;
            if (item.selling_plan_allocation != null) return true;
          }

          return false;
        };

        const updates = {};
        const keep = [];
        for (let i = 0; i < gifts.length; i++) {
          if (giftHasParent(gifts[i])) {
            keep.push(gifts[i]);
          } else {
            updates[gifts[i].key] = 0;
          }
        }

        if (keep.length > 0) {
          if (keep[0].quantity !== 1) {
            updates[keep[0].key] = 1;
          }
          for (let i = 1; i < keep.length; i++) {
            updates[keep[i].key] = 0;
          }
        }

        if (Object.keys(updates).length === 0) return null;

        const sections = this.getSectionsToRender().map((section) => section.id);
        return fetch(window.routes.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        }).then((response) => response.json());
      })
      .then((parsedState) => {
        if (!parsedState) return;

        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems && typeof cartDrawerItems.renderSections === 'function') {
          cartDrawerItems.renderSections(parsedState);
        } else if (parsedState.sections && parsedState.sections['cart-drawer']) {
          const cartDrawerRoot = document.getElementById('CartDrawer');
          if (cartDrawerRoot) {
            const newInnerHTML = this.getSectionInnerHTML(
              parsedState.sections['cart-drawer'],
              '#CartDrawer'
            );
            if (newInnerHTML) {
              runCartDrawerDomUpdate(() => {
                cartDrawerRoot.innerHTML = newInnerHTML;
                const overlay = this.querySelector('#CartDrawer-Overlay');
                if (overlay) {
                  overlay.addEventListener('click', this.close.bind(this));
                }
              });
            }
          }
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        if (typeof window.refreshCartIconBubble === 'function') {
          window.refreshCartIconBubble();
        }
      })
      .catch(() => {})
      .finally(() => {
        this._giftDedupeInProgress = false;
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  renderSections(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionHtml = parsedState.sections && parsedState.sections['cart-drawer'];
    const cartDrawerRoot = document.getElementById('CartDrawer');

    if (sectionHtml && cartDrawerRoot && cartDrawer) {
      const newInnerHTML = cartDrawer.getSectionInnerHTML(sectionHtml, '#CartDrawer');
      if (newInnerHTML) {
        runCartDrawerDomUpdate(() => {
          cartDrawerRoot.innerHTML = newInnerHTML;
          const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }
        });
      }
    } else {
      return this.refreshCartDrawerSection(parsedState.item_count);
    }

    const bubbleHtml = parsedState.sections && parsedState.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      const bubbleParent = document.getElementById('cart-icon-bubble');
      if (bubbleParent) {
        const bubbleTarget = bubbleParent.querySelector('.shopify-section') || bubbleParent;
        const bubbleInner = this.getSectionInnerHTML(bubbleHtml, '.shopify-section');
        if (bubbleInner) {
          bubbleTarget.innerHTML = bubbleInner;
        }
      }
    } else if (typeof window.updateCartIconBubble === 'function') {
      window.updateCartIconBubble(parsedState.item_count);
    }

    return Promise.resolve();
  }

  refreshCartDrawerSection(itemCount) {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('#CartDrawer');
        const target = document.getElementById('CartDrawer');
        const cartDrawer = document.querySelector('cart-drawer');

        if (source && target) {
          runCartDrawerDomUpdate(() => {
            target.innerHTML = source.innerHTML;
            if (cartDrawer) {
              const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay) {
                overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
              }
            }
          });
        }

        this.updateCartDrawerEmptyState(itemCount);

        if (typeof window.refreshCartIconBubble === 'function') {
          window.refreshCartIconBubble();
        }
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function setCartDrawerCheckoutLoading(isLoading) {
  const checkoutButton = document.getElementById('CartDrawer-Checkout');
  if (!checkoutButton) return;

  checkoutButton.classList.toggle('is-loading', isLoading);
  checkoutButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
}

function initCartDrawerCheckoutLoader() {
  if (initCartDrawerCheckoutLoader.initialized) return;
  initCartDrawerCheckoutLoader.initialized = true;

  document.addEventListener('click', function (event) {
    const checkoutButton = event.target.closest('#CartDrawer-Checkout');
    if (!checkoutButton || checkoutButton.disabled) return;
    setCartDrawerCheckoutLoading(true);
  });

  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'CartDrawer-Form') return;
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    if (!checkoutButton || checkoutButton.disabled) return;
    setCartDrawerCheckoutLoading(true);
  });
}

initCartDrawerCheckoutLoader();